import { combineReducers } from 'redux'
import {leftSidebar, dashboardLayout, dragAndDropLayout} from './settings/reducer'
import toaster from './toaster/reducer'
import auth from './auth/reducer'
import themesAvailable from './themesAvailable/reducer'
import info from './info/reducer'
import infoLogin from './info-login/reducer'
import item from './item/reducer'
import clients from './clients/reducer'
import clientGroups from './clientGroups/reducer'
import clientInterventions from './clientInterventions/reducer'
import analyses from './analyses/reducer'
import forms from './forms/reducer'
import formsDownload from './formsDownload/reducer'
import dataStructures from './dataStructures/reducer'
import contracts from './contracts/reducer'
import contractInterventions from './contractInterventions/reducer'
import strings from './strings/reducer'
import adminStrings from './adminStrings/reducer'
import filters from './filters/reducer'
import users from './users/reducer'
import advisors from './advisors/reducer'
import consultantPositions from './consultantPositions/reducer'
import managerPositions from './managerPositions/reducer'
import certifications from './certifications/reducer'
import contractualData from './contractualData/reducer'
import brokerages from './brokerages/reducer'
import billingOverview from './billingOverview/reducer'
import billingReports from './billingReports/reducer'
import billingRules from './billingRules/reducer'
import billingReportFormats from './billingReportFormats/reducer'
import billingClosures from './billingClosures/reducer'
import billingUnassignedEntries from './billingUnassignedEntries/reducer'
import billingMonthlyBalance from './billingMonthlyBalance/reducer'
import billingTables from './billingTables/reducer'
import billingTemplates from './billingTemplates/reducer'
import billingFunds from './billingFunds/reducer'
import enums from './enums/reducer'
import lazyLoad from './lazyLoad/reducer'
import batchList from './batchList/reducer'
import batchSimpleList from './batchSimpleList/reducer'
import notifications from './notifications/reducer'
import contractDispatches from './contractDispatches/reducer'
import contractRisks from './contractRisks/reducer'
import activities from './activities/reducer'
import activitiesSettings from './activitiesSettings/reducer'
import liquidations from './liquidations/reducer'
import liquidationTemplates from './liquidationTemplates/reducer'
import liquidators from './liquidators/reducer'
import liquidationsDashboard from './liquidationsDashboard/reducer'
import assistants from './assistants/reducer'
import backoffices from './backoffices/reducer'
import leads from './leads/reducer'
import leadStorages from './leadStorages/reducer'
import contractStatistics from './contractStatistics/reducer'
import contractReminders from './contractReminders/reducer'
import callData from './callData/reducer'
import roles from './roles/reducer'
import companies from './companies/reducer'
import settingsMessages from './settingsMessages/reducer'
import settingsEnums from './settingsEnums/reducer'
import settingsEmailtemplates from './settingsEmailtemplates/reducer'
import settingsPdftemplates from './settingsPdftemplates/reducer'
import settingsProducts from './settingsProducts/reducer'
import businesscases from './businesscases/reducer'
import businesscasesTypes from './businesscasesTypes/reducer'
import businesscasesColumns from './businesscasesColumns/reducer'
import businesscasesTags from './businesscasesTags/reducer'
import businesscasesDashboard from './businesscasesDashboard/reducer'
import liquidationsColumns from './liquidationsColumns/reducer'
import clientsFormtypes from './clientsFormtypes/reducer'
import clientsStates from './clientsStates/reducer'
import companiesVpps from './companiesVpps/reducer'
import usersContacts from './usersContacts/reducer'
import logsClientlogs from './logsClientlogs/reducer'
import logsExportlogs from './logsExportlogs/reducer'
import companiesBusinessproducts from './companiesBusinessproducts/reducer'
import settingsCrmmodules from './settingsCrmmodules/reducer'
import settingsCrmclientmodules from './settingsCrmclientmodules/reducer'
import companiesGlobalbusinessproducts from './companiesGlobalbusinessproducts/reducer'
import extranetsDiContracts from './extranetsDiContracts/reducer'
import extranetsDiStates from './extranetsDiStates/reducer'
import extranetsKoContracts from './extranetsKoContracts/reducer'
import extranetsKoStates from './extranetsKoStates/reducer'
import extranetsCpContracts from './extranetsCpContracts/reducer'
import extranetsCpStates from './extranetsCpStates/reducer'
import extranetsUnContracts from './extranetsUnContracts/reducer'
import extranetsUnStates from './extranetsUnStates/reducer'
import extranetsPlContracts from './extranetsPlContracts/reducer'
import extranetsPlStates from './extranetsPlStates/reducer'
import extranetsSlContracts from './extranetsSlContracts/reducer'
import extranetsSlStates from './extranetsSlStates/reducer'
import extranetsCsContracts from './extranetsCsContracts/reducer'
import extranetsCsStates from './extranetsCsStates/reducer'
import extranetsMaContracts from './extranetsMaContracts/reducer'
import extranetsMaStates from './extranetsMaStates/reducer'
/*extranets_here1*/
import billingPremiumbillings from './billingPremiumbillings/reducer'
import settingsCredentials from './settingsCredentials/reducer'
import contractsStates from './contractsStates/reducer'
import banksAccounts from './banksAccounts/reducer'
import banksTransactions from './banksTransactions/reducer'
import crecordsEmployees from './crecordsEmployees/reducer'
import crecordsProjects from './crecordsProjects/reducer'
import crecordsDayworks from './crecordsDayworks/reducer'
import crecordsEstates from './crecordsEstates/reducer'
import usersAllnotifications from './usersAllnotifications/reducer'
import billingTariffs from './billingTariffs/reducer'
import billingTariffentries from './billingTariffentries/reducer'
import liquidationsStats from './liquidationsStats/reducer'
import liquidationsLongstandings from './liquidationsLongstandings/reducer'
import settingsTagcategories from './settingsTagcategories/reducer'
import settingsTags from './settingsTags/reducer'
import marketings from './marketings/reducer'
import activitiesProviders from './activitiesProviders/reducer'
import activitiesTypes from './activitiesTypes/reducer'
import liquidationsTodos from './liquidationsTodos/reducer'
import billingPayments from './billingPayments/reducer'
import calendarEvents from './calendarEvents/reducer'

import clientsSigntypes from './clientsSigntypes/reducer'
/*modules_here1*/

import clz_auth from './client-zone/auth/reducer'
import clz_liquidations from './client-zone/liquidations/reducer'
import clz_contracts from './client-zone/contracts/reducer'

export default combineReducers({
  toaster,
  dashboardLayout,
  dragAndDropLayout,
  leftSidebar,
  themesAvailable,
  auth,
  info,
  infoLogin,
  item,
  clients,
  clientGroups,
  clientInterventions,
  analyses,
  forms,
  formsDownload,
  dataStructures,
  contracts,
  strings,
  adminStrings,
  filters,
  users,
  advisors,
  consultantPositions,
  managerPositions,
  certifications,
  contractualData,
  brokerages,
    billingOverview,
  billingReports,
  billingRules,
  billingReportFormats,
  billingClosures,
  billingUnassignedEntries,
  billingMonthlyBalance,
  billingTables,
  billingTemplates,
  billingFunds,
  enums,
  lazyLoad,
  batchList,
  batchSimpleList,
  notifications,
  contractDispatches,
  contractRisks,
  contractInterventions,
  activities,
  activitiesSettings,
  liquidations,
  liquidationTemplates,
  liquidators,
  liquidationsDashboard,
  assistants,
  backoffices,
  contractStatistics,
  contractReminders,
  leads,
  leadStorages,
  callData,
  roles,
  companies,
  settingsMessages,
  settingsEnums,
  settingsEmailtemplates,
  settingsPdftemplates,
  settingsProducts,
  businesscases,
  businesscasesTypes,
  businesscasesColumns,
  businesscasesTags,
  businesscasesDashboard,
  liquidationsColumns,
  clientsFormtypes,
  clientsStates,
  companiesVpps,
  usersContacts,
  logsClientlogs,
  logsExportlogs,
  companiesBusinessproducts,
  settingsCrmmodules,
  settingsCrmclientmodules,
  companiesGlobalbusinessproducts,
  extranetsDiContracts,
  extranetsDiStates,
  extranetsKoContracts,
  extranetsKoStates,
  extranetsCpContracts,
  extranetsCpStates,
  extranetsUnContracts,
  extranetsUnStates,
  extranetsPlContracts,
  extranetsPlStates,
  extranetsSlContracts,
  extranetsSlStates,
  extranetsCsContracts,
  extranetsCsStates,
  extranetsMaContracts,
  extranetsMaStates,
/*extranets_here2*/
  billingPremiumbillings,
  settingsCredentials,
  contractsStates,
  banksAccounts,
  banksTransactions,
  crecordsEmployees,
  crecordsProjects,
  crecordsDayworks,
  crecordsEstates,
  usersAllnotifications,
  billingTariffs,
  billingTariffentries,
  liquidationsStats,
  liquidationsLongstandings,
  settingsTagcategories,
  settingsTags,
  marketings,
  activitiesProviders,
  activitiesTypes,
  liquidationsTodos,
  billingPayments,
    calendarEvents,

      clientsSigntypes,
/*modules_here2*/
  clz_auth,
  clz_liquidations,
  clz_contracts,
})